
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.66634 3.52675C7.08881 3.40101 7.53636 3.3335 7.99967 3.3335C10.577 3.3335 12.6663 5.42283 12.6663 8.00016C12.6663 10.5775 10.577 12.6668 7.99967 12.6668C5.42235 12.6668 3.33301 10.5775 3.33301 8.00016C3.33301 7.65691 3.37007 7.32232 3.4404 7.00016","stroke":"#10001F","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    